import { apis } from '@/api'

export default {
  getGeneralSettings: (params: any) => apis.$get('/general_settings', params)
}
